import styled from 'styled-components';
import { theme } from '../../theme/GlobalTheme';
import backgroundImage from '../../assets/data-background.jpg';

export const Container = styled.div`
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const ContentSection = styled.section`
  background-color: ${theme.colors.white};
  margin: ${theme.spacing.xl} auto;
  max-width: 1000px;
  width: 90%;
  border-radius: ${theme.borderRadius.medium};
  border-left: 5px solid ${theme.colors.primary};
  box-shadow: ${theme.shadows.card};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 95%;
    margin: ${theme.spacing.lg} auto;
  }
`;

export const SectionTitle = styled.h2`
  color: ${theme.colors.primary};
  font-size: ${theme.typography.fontSize.h2};
  font-weight: ${theme.typography.fontWeight.bold};
  margin: 0;
  padding: ${theme.spacing.xl} ${theme.spacing.xl} 0 ${theme.spacing.xl};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.fontSize.h3};
    padding: ${theme.spacing.lg} ${theme.spacing.lg} 0 ${theme.spacing.lg};
    margin: 0;
  }
`;

export const SectionContent = styled.div`
  padding: ${theme.spacing.xl};
  color: ${theme.colors.text};
  font-size: ${theme.typography.fontSize.body};
  line-height: 1.6;
  
  p {
    margin: 0 0 ${theme.spacing.lg} 0;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  p + ul {
    margin-top: -${theme.spacing.md};
  }
  
  ul {
    margin: ${theme.spacing.xs} 0;
    padding-left: ${theme.spacing.xl};
    
    li {
      margin-bottom: ${theme.spacing.xs};
      line-height: 1.6;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  strong {
    color: ${theme.colors.textDark};
    font-weight: ${theme.typography.fontWeight.bold};
  }
  
  a {
    color: ${theme.colors.primary};
    text-decoration: underline;
    font-weight: ${theme.typography.fontWeight.bold};
    
    &:hover {
      color: ${theme.colors.secondary};
    }
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg};
    font-size: 14px;
  }
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${theme.spacing.lg};
  margin-top: ${theme.spacing.xl};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.md};
  }
`;

export const FeatureCard = styled.div`
  background-color: ${theme.colors.white};
  border: 2px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.lg};
  text-align: center;
`;

export const FeatureTitle = styled.h4`
  color: ${theme.colors.primary};
  font-size: ${theme.typography.fontSize.h4};
  font-weight: ${theme.typography.fontWeight.bold};
  margin: 0 0 ${theme.spacing.md} 0;
  text-transform: uppercase;
  font-size: 18px;
`;

export const FeatureDescription = styled.p`
  color: ${theme.colors.text};
  font-size: ${theme.typography.fontSize.body};
  line-height: 1.5;
  margin: 0 0 ${theme.spacing.lg} 0;
`;

export const ContactSection = styled.section`
  background-color: rgba(0, 33, 105, 0.9);
  margin: ${theme.spacing.xl} auto;
  max-width: 1000px;
  width: 90%;
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.xl};
  text-align: center;
  box-shadow: ${theme.shadows.card};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 95%;
    padding: ${theme.spacing.lg};
  }
`;

export const ContactText = styled.p`
  color: ${theme.colors.white};
  font-size: 18px;
  line-height: 1.6;
  margin: 0;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.fontSize.body};
  }
`;

export const ContactLink = styled.a`
  color: ${theme.colors.white};
  text-decoration: underline;
  font-weight: ${theme.typography.fontWeight.bold};
  transition: color 0.2s ease-in-out;
  
  &:hover {
    color: ${theme.colors.tertiary};
  }
`;

export const DeveloperCredit = styled.footer`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  text-align: center;
  padding: ${theme.spacing.lg};
  margin-top: ${theme.spacing.xl};
  
  p {
    margin: 0;
    font-size: ${theme.typography.fontSize.body};
  }
`;

export const DisclaimerText = styled.div`
  margin-top: ${theme.spacing.md};
  padding-top: ${theme.spacing.md};
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: ${theme.colors.text};
  font-size: ${theme.typography.fontSize.small};
  line-height: 1.5;
  text-align: left;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  
  p {
    margin: 0 0 ${theme.spacing.sm} 0;
    font-size: ${theme.typography.fontSize.small};
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 ${theme.spacing.md};
  }
`;
